module.exports = __webpack_public_path__ + "static/media/cosmosbanner_sm3.7b271666.png";